import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
  PrescriberInService,
  transformPrescriberForUI,
} from '../../pages/PrescriberProfilePage/utils'
import { setPrescriber } from '../../pages/NewScriptPage/ScriptForm/PrescriberSlice'
import { Permission } from '../../types/permission'
import ApiClient from '../../utils/api/ApiClient'

export interface EhrBootstrapResponse {
  userId: string
  prescriber: PrescriberInService
  permissions: Permission[]
  launchInstanceId: string
  patientId?: string
}

interface EhrLaunchState {
  launchInstanceId?: string
  hasError: boolean
}

export const EhrLaunchClient = {
  Bootstrap: createAsyncThunk('ehrLaunch/bootstrap', async (_, thunkAPI) => {
    const { data } = await ApiClient.post<EhrBootstrapResponse>('/auth/ehr-launch/bootstrap')
    thunkAPI.dispatch(setPrescriber(transformPrescriberForUI(data.prescriber)))
    return data
  }),
}

const initialState: EhrLaunchState = {
  hasError: false,
}

const ehrLaunchSlice = createSlice({
  name: 'ehrLaunch',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(EhrLaunchClient.Bootstrap.fulfilled, (state, { payload }) => {
        state.launchInstanceId = payload.launchInstanceId
        state.hasError = false
        localStorage.setItem('user_id', payload.userId)
        localStorage.setItem('prescriber', JSON.stringify(payload.prescriber))
        localStorage.setItem('permissions', JSON.stringify(payload.permissions))
      })
      .addCase(EhrLaunchClient.Bootstrap.rejected, (state) => {
        state.hasError = true
      })
  },
})

export default ehrLaunchSlice.reducer
